import axios, { AxiosError, AxiosResponse } from 'axios'
import { getAPIURL } from '../GlobalComponents/URLs'

const sleep = (delay: number) => {
    return new Promise((resolve) => {
        setTimeout(resolve, delay)
    })
}

function RedirectUser() {
    let redirectURL = getAPIURL().replace('/webapi/', '') + '/logon.aspx'
    if (redirectURL.toUpperCase().includes('NET'))
        redirectURL = getAPIURL().replace('/webapi/', '') + '/masterclient/main.aspx'
    let originalURL = window.location.href
    window.location.href = redirectURL + '?Redirect=' + encodeURIComponent(originalURL)
}

axios.defaults.baseURL = getAPIURL()
axios.defaults.withCredentials = true
axios.interceptors.response.use(
    async (response) => {
        return response
    },
    (error: AxiosError) => {
        const status = error.response ? error.response.status : undefined
        if (status) {
            switch (status) {
                case 400:
                    RedirectUser()
                    break
                case 401:
                    //toast.error('unauthorised');
                    RedirectUser()
                    break
                case 404:
                    //history.push('/not found');
                    //toast.error('not found');

                    break
                case 500:
                    // @ts-ignore
                    //setMessage('Server Error')
                    //history.push('/server-error')
                    break
            }
        }

        return Promise.reject(error)
    }
)

const Body = <T>(response: AxiosResponse<T>) => response.data

const Requests = {
    get: <T>(url: string) => axios.get<T>(url).then(Body),
    post: <T>(url: string, body: {}) => axios.post<T>(url, body).then(Body),
    put: <T>(url: string, body: {}) => axios.put<T>(url, body).then(Body),
    del: <T>(url: string) => axios.delete<T>(url).then(Body),
}

const AxiosAgent = {
    Requests,
}

export default AxiosAgent
